<template>
    <div class="setDateDoc">
        <span :class="['view-date']">
            <label for="form-label">{{ item.label }}</label>
            <!-- {{ item.dateDoc | moment("YYYY MMM DD, hh:mm A")}} -->
            <span class="input-date">
                <i class="far fa-calendar-alt"></i>
                {{ formattedDate }}
            </span>
            <!-- <br /> -->
            <!-- {{ new Date(item.dateDoc).toLocaleTimeString("en-us", optionsTime)}} -->
        </span>
        <date-picker
            v-model="item.dateDoc"
            :default-value="dateSelected"
            value-type="format"
            format="YYYY-MM-DD"
            type="date"
            :input-attr="{'data-value': item.dateDoc}"
            :show-time-panel="showTimePanel"
            :minute-step="5"
            input-class="mx-input-setDateDoc"
            @open="dueDateOpen(item)"
            @close="closeDatePicker(item)"
            @input="changeDate()"
            :clearable="false"
            :show-second="false"
            :confirm="true"
            use12h
            :open.sync="item.openCal>0"
            >
            <!-- metodos no usados
            :disabled-date="notBeforeToday()"
            -->
            <template v-slot:header="{ emit }" class="header-date-picker">
                <button class="mx-btn mx-btn-text btn-today" @click="emit(new Date())">Today: {{ isDateNow }}</button>
            </template>
            <template v-slot:footer>
                <!-- <button type="button" class="mx-btn mx-btn-text" @click="toggleTimePanel" v-if="!showTimePanel">
                    Hours
                </button> -->
                <button type="button" class="mx-btn mx-btn-text" @click="toggleTimePanel()" v-if="showTimePanel">
                    Date
                </button>
                <!-- <button type="button" class="mx-btn mx-btn-text" @click="onResetCal(item)" v-if="resetCal">
                    Cancel
                </button> -->
                <button type="button" class="mx-btn mx-btn-text" @click="closeDatePicker(item)" >
                    Close
                </button>
            </template>
        </date-picker>
    </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import './setDateDoc.scss';
// import 'vue2-datepicker/locale/es'; // Import the Spanish locale
import moment from 'moment';
export default {
    name: 'setDateDoc',
    props: {
        dateDoc: {
            type: [Date, String],
            default: () => new Date(),
        },
        labelDoc: {
            type: String,
            default: 'Date:',
        },
    },
    components: {
        "date-picker": DatePicker,
    },
    data() {
        return {
            dateSelected: new Date(),
            showTimePanel: false,
            optionsTime: {
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true
            },
            item: {
                dateDoc: this.dateDoc,
                label: this.labelDoc,
                openCal: 0,
            },
            resetCal: false,
        };
    },
    computed: {
        formattedDate() {
            if (this.$moment && this.item.dateDoc) {
                const date = this.$moment(this.item.dateDoc);
                return date.isValid() ? date.format("MMM DD, YYYY") : this.item.dateDoc;
            }
            return this.item.dateDoc;
        },
        isDateNow() {
            return this.$moment ? this.$moment(new Date()).format("MMM DD, YYYY") : this.item.dateDoc;
        },
    },
    methods: {
        toggleTimePanel() {
            this.showTimePanel = !this.showTimePanel;
        },
        dueDateOpen(item) {
            item.openCal = 1;
            this.resetCal = true;
        },
        closeDatePicker(item) {
            item.openCal = 0;
            this.resetCal = false;
        },
        changeDate() {
            this.$emit('returnValue', {
                "date_doc": this.item.dateDoc
            })
        },
        notBeforeToday(date) {
            // return date.getTime() < new Date().getTime();
        },
    },
}
</script>
<style scoped>

</style>
